<template>
<div>
    <h2 class="kojin-title"><slot>タイトル</slot></h2>
  </div>
    <span class="sp_only">

      <div v-if="checkin_flg==1" class="sp_button_area" style="text-align:center;
        flex-direction: row;justify-content: center;">
        <button class="btn btn-primary mx-aut" 
          style="font-size: 13.5px;width: 200px; height: 40px;margin:15px 5px 5px;padding: 0;background-color: #F5F5F5;color:#000;border:1px solid #000" 
          v-on:click="codereader()">二次元コード読取
        </button>
      </div><br>

      <div v-on:click="Smart_logout" style="align-items: center;"><u>ログアウト</u></div><br>

    </span>

    <div class="p-2 " style="margin-top:0;background-color:white">
      <div id="manual_area">
        <span v-on:click="manual_open"><img class="m_icon" src="../../../images/mark/manual.png"  />体験プログラムのマニュアル</span>
      </div>

      <br clear="all">
    </div>

  <!--フッター-->
  <!-- <FooterArea v-on:call="call"/> -->
  <!--メッセージを表示するモーダルウィンドウ-->
  <component v-bind:is="contentMessage"
            v-bind:message_text="message"
            v-bind:message_cat="message_cat"
            v-bind:message_flag="message_flag"
            @close_message="Close_message"
            @ok_message="OK_message"/>

</template>

<script setup>
/* eslint-disable */ 
import { logout } from '../../js/userdata_shakyo.js'

import { ref } from 'vue';

let message = ref("")//表示するメッセージ
let message_cat = ref(0)// メッセージのカテゴリ（0：OKのみ、1：OK or キャンセルの選択式）
let message_method = ref("")// こちら（親コンポーネント）に帰った時、どの処理（関数）を行うのか（message_catが1の時のみ）
let message_flag = ref(false)//表示・非表示フラグ

const emit = defineEmits(['call'])

const props = defineProps(['param'])

// チェックイン機能の利用フラグ
let checkin_flg = ref(props.param.checkin_flg)

// 二次元コード（スマホのみ）移動
const codereader = function() {
  emit('call', { cmd:'Readcode'})
  // router.push('/'+cityname+'/Kanri/Readcode')
}

// メッセージを表示するウィンドウでOKを押された時
let OK_message = function(){ 
    Close_message();//メッセージを表示するウィンドウを閉じる
    
    if(message_method.value == ""){

    }
}

// メッセージを表示するウィンドウを閉じる
let Close_message = function(){
    message_flag.value = false;
    contentMessage.value = null
}

// スマホ用ログアウト
const Smart_logout = () => {
    logout()
}
    
  let manual_open = function(){
    let url = "https://zest-newsprint-e3e.notion.site/161c0be34f8f80fc87baf85432ed7220"
    window.open(url,"_blank")
}
    
</script>
<style scoped>
.hov,.hov_over,.hov_over:hover {
  background-color: white;
  cursor: default;
}
.hov:hover {
  background-color:royalblue;
  cursor: pointer;

}

.list_bunrui {
  font-size: 14px;
}

.program_naiyo{
  width:90%;
  margin-left:10px
}
@media screen and (min-width: 961px) {

/* PC版 */

  .sp_button_area{
      display: none
  }
}
@media screen and (max-width: 960px) {

  /* スマホ版 */

  .sp_button_area{
      display: flex
  }
}
</style>
